<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'app',
  updated: function() {
    initBox();
    initPage();
  },
  mounted: function() {
    // alert(1);
    initBox();
    initPage();
  }
}
function initBox() {

  $('#app').find('.box').each(function() {

    $(this).append('<div class="top-left"></div><div class="top-right"></div><div class="bottom-left"></div><div class="bottom-right"></div>');
  });
}

function initPage() {

  var page = $('#app > .page');
  
  setTimeout(function() {
    page.find('> .page-content').css({
      minHeight: $('body').height() - 200
    })
    page.find('> .page-content').addClass('init');
    
    page.find('> .page-top').addClass('init');
  }, 0)
}
</script>

<style lang="less">
@base-color: rgb(43,229,245);
@base-opacity: 0.6;
@green-color: rgba(27,255,104,1);


.base-color(@opacity: 1) {
  color: rgba( 43, 229, 245,@opacity);
}
.green-color(@opacity: 1) {
  color: rgba(27,255,104,@opacity);
}

.border-color(@opacity: 0.4) {
  border-color: rgba( 43, 229, 245,@opacity);
}

.base-border(@opacity: 0.4) {
  border-width: 1px;
  border-style: solid;
  border-color: rgba( 43, 229, 245, @opacity);
}

.base-background-color(@opacity: 0.2) {
  background-color: rgba( 43, 229, 245,@opacity);
}


[v-cloak] {
  display: none;
}

html, body {
  height: 100%;
  position: relative;
  color: #fff;
  font-size: 14px;

  font-family: 'Serif';
}

body {
  min-width: 1240px;
  min-height: 830px;
  background: url(/web-static/img/bg-pattern.png) #000 fixed;

}

#app {
  position: relative;
  overflow: hidden;
}


a {
  color: #fff;
  cursor: pointer;

  &:hover {
    cursor: pointer;
    text-decoration: none;
    color: #fff;
  }

  &:link {
    cursor: pointer;
    text-decoration: none;
    color: #fff;
  }

  &:active {
    text-decoration: none;
    color: #fff;
  }

  &:visited {
    text-decoration: none;
    color: #fff;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in below version 2.1.8 */ {
  opacity: 0
}

.box {
  position: relative;
  .base-border;

  .top-left, .top-right, .bottom-left, .bottom-right {
    background-image: url('/web-static/img/box-corner.png');
    background-size: 100% auto;
    position: absolute;
    width: 7px;
    height: 7px;
    z-index: 10;
    opacity: 0.8;
  }

  .top-left {
    top: -4px;
    left: -4px;
  }
  .top-right {
    top: -4px;
    right: -4px;
  }
  .bottom-left {
    bottom: -4px;
    left: -4px;
  }
  .bottom-right {
    bottom: -4px;
    right: -4px;
  }

  .box-inner {
    .base-border;
    margin: 2px;
  }
}



.vertical-line(@left: auto, @right: auto) {
  .base-background-color(0.4);
  border-width: 0 0 0 1px;
  height: 100%;
  width: 1px;
  position: absolute;
  top: 0;
  left: @left;
  right: @right;

  .top-edge {
    position: absolute;
    top: 0;
    left: 0;
    height: 7px;
    width: 2px;
    .base-background-color(0.6);
  }

  .bottom-edge {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 7px;
    width: 2px;
    .base-background-color(0.6);
  }
}

.horizontal-line {
  // margin-top: 60px;
  // margin: 60px 120px;
  height: 1px;
  .base-background-color(.3);
  position: relative;

  .bg-left, .bg-right {
    position: absolute;
    top: 0;
    width: 6px;
    height: 1px;
  }

  .bg-left {
    left: 0;
    width: 20px;
    .base-background-color(.8);
  }

  .bg-right {
    right: 0;
    .base-background-color(.6);
  }

  .bg-center {
    position: absolute;
    top: 0px;
    left: 30%;
    width: 10px;
    margin-left: 0px;
    height: 1px;
    .base-background-color(.4);
  }
}



.page {
  position: relative;
  min-height: 100%;

  .page-content {
    padding: 0 20px;
    width: 1240px;
    position: relative;
    left: 0px;
    height: auto;
    min-height: 700px;
    margin: 60px auto 60px auto;
    overflow: hidden;

    &.init {
      .left, .right {
        opacity: 1;
      }
      .left {
        left: 0px;
      }
      .right {
        top: 0px;
      }
    }

    .left {
      float: left;
      width: 200px;
      opacity: 0;
      position: relative;
      left: -200px;
      transition: .2s opacity, .2s left;

      .heading {
        font-size: 50px;
        line-height: 1em;
        font-family: Arial;
      }
      
      .nav {
        margin-top: 20px;
        
        .nav-item {
          margin-bottom: 10px;
          cursor: pointer;

          &:hover {
            a {
              .base-color;
            }
          }

          a {
            //.base-color;
            font-size: 12px;
          }
        }
      }
    }

    .right {
      float: left;
      width: 1000px;
      position: relative;
      top: -100px;
      opacity: 0;
      transition: .6s .2s opacity, .6s .2s top;
    }
  }

  
}


.page-top {
  position: relative;
  // opacity: 0;
  // transition: 0.4s opacity;
  .base-border(1);
  border-width: 2px 0 1px 0;
  border-bottom-color: #041719;
  background-color: rgba(0,0,0,1);
  

  &.init {
    // opacity: 1;
  }

  &:hover {
    .page-top-bg {
      opacity: .4;
    }
  }
  
  .page-top-bg {
    background-image: url(/web-static/img/page-top-bg.png);
    background-position: top center;
    background-repeat: no-repeat;
    
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    opacity: .05;
    transition: opacity 2s;
  }

  .page-top-bg-2 {
    background-image: linear-gradient(to top, #000, transparent);
    background-position: top center;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    z-index: 1;
    opacity: 1;
  }
  
  .page-top-content {
    width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    padding-top: 20px;
    position: relative;
    z-index: 2;

    .logo {
      width: 200px;
      position: relative;
      left: -30px;
      margin-bottom: 20px;

      img {
        width: 100%;
        height: auto;
      }
    }


    .menu {
      margin-top: 60px;
      float: left;
      list-style: none;
      overflow: hidden;
      position: absolute;
      bottom: 0px;
      left: 200px;

      li {
        margin-right: 20px;
        height: 8px;
        display: inline-block;
        .border-color(0.8);
        border-style: solid;
        border-width: 0 0 0 1px;
        line-height: 1em;
        padding-left: 10px;
        font-family: Arial;
        transition: height 0.25s;

        .router-link-active {
          .base-color;
        }

        &:hover {
          border-color: @base-color;
          height: 13px;
          a {
            // .green-color;
            .base-color;
          }
        }

        a {
          vertical-align: top;
          font-size: 18px;
          // transition: all 0.5s;
          text-shadow: 0px 0px 10px rgba(0,0,0,.5);
        }
      }
    }
  }

  
}

.page-bottom {
  position: relative;
  left: 0;
  bottom: 0;
  padding-bottom: 30px;
  width: 100%;
  // opacity: 0;
  // transition: 0.4s opacity;
  .base-border(1);
  border-width: 1px 0 0px 0;
  border-top-color: #041719;
  margin-top: 60px;
  background-color: rgba(0,0,0,1);

  &.init {
    // opacity: 1;
  }
  
  .page-bottom-bg {
    background-image: url(/web-static/img/page-bottom-bg.png);
    background-position: top center;
    background-repeat: no-repeat;
    
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    opacity: .1;
  }

  .page-bottom-bg-2 {
    background-image: linear-gradient(to bottom, #000, transparent);
    background-position: top center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 1;
  }
  
  .page-bottom-content {
    width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    padding-top: 20px;
    position: relative;
    text-align: center;
    z-index: 2;

    .logo {
      width: 240px;
      position: relative;
      left: -40px;

      img {
        width: 100%;
        height: auto;
      }
    }


    .menu {
      display: inline-block;
      list-style: none;
      overflow: hidden;
      padding: 0;
      padding-left: 20px;

      li {
        margin-right: 20px;
        height: 8px;
        display: inline-block;
        .border-color(0.8);
        border-style: solid;
        border-width: 0 0 0 1px;
        line-height: 1em;
        padding-left: 10px;
        font-family: Arial;
        transition: height 0.25s;

        .router-link-active {
          .base-color;
        }

        &:hover {
          border-color: @base-color;
          height: 13px;
          a {
            // .green-color;
            .base-color;
          }
        }

        a {
          vertical-align: top;
          font-size: 12px;
          // transition: all 0.5s;
        }
      }
    }

    .copyright {
      font-size: 12px;
      font-family: Arial;
    }
  }

  
}

.page-home {
  height: 100%;
  overflow: hidden;

  &.init {
    .bg-2, .bg-3 {
      opacity: 1;
    }
    .left-line-1 {
      .vertical-line(20px, auto);
    }
    .left-line-2 {
      .vertical-line(41px, auto);
    }

    .left-line-3 {
      .vertical-line(240px, auto);
    }

    .left {
      left: 41px;
      opacity: 1;

      .menu {
        height: 354px;
        opacity: 1;

        .sub-heading {
          opacity: 1;
        }
      }
    }
    .right {
      top: 0;
      opacity: 1;

      .visual {
        opacity: 1;
      }

      .videos .box {
        height: 113px;
        width: 200px;
        margin-left: 0px;
        margin-right: 0px;

        .video {
          cursor: pointer;
          video {
            width: 100%;
            height: 100%;
          }
        }
      }

      .videos .sub-heading {
        opacity: 1;
      }

      .news-list {
        .box {
          height: 260px;
          width: 200px;
          margin-left: 0px;
          margin-right: 0px;
        }
        .news {
          opacity: 1;
        }
        .sub-heading {
          opacity: 1;
        }
      }

      
    }

    .right-line-1 {
      .vertical-line(auto, 20px);
    }

    .right-line-2 {
      .vertical-line(auto, 41px);
    }

    .right-line-3 {
      .vertical-line(auto, 240px);
    }
  }

  .bg-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .bg-1, .bg-2, .bg-3 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: auto 100%; 
    background-repeat: no-repeat;
    opacity: 0;
    text-align: center;
    
    img {
      vertical-align: bottom;

    }
  }

  .bg-1 {
    background-image: url(/web-static/img/home-bg-1.png);
    background-position:  bottom center;
    transition: 3s opacity;

    img {
      width: 100%;
      height: auto;
    }
  }

  .bg-2 {
    background-image: url(/web-static/img/home-bg-2.png);
    background-position:  bottom center;
    transition: 3s .2s opacity;

    img {
      width: 100%;
      height: auto;
    }
  }

  .bg-3 {
    top: 60px;
    height: 500px;
    background-image: url(/web-static/img/home-bg-3.png);
    background-size: 80px auto;
    background-position: top center;
    transition: 5s 3.2s opacity;

    img {
      width: auto;
      height: auto;
    }
  }

  .left-line-1 {
    .vertical-line(0px, auto);
    
    transition: .6s left;
  }

  .left-line-2 {
    .vertical-line(0px, auto);
    transition: 0.6s left;
  }

  .left-line-3 {
    .vertical-line(0px, auto);
    transition: 0.6s left;
  }

  .right-line-1 {
    .vertical-line(auto, 0px);
    transition: 0.6s right;
  }

  .right-line-2 {
    .vertical-line(auto, 0px);
    transition: 0.6s right;
  }

  .right-line-3 {
    .vertical-line(auto, 0px);
    transition: 0.6s right;
  }

  
  .left {
    opacity: 0;
    left: 0px;
    transition: .6s .6s left, .6s .6s opacity;

    .menu {
      transition: 1s 1.2s height, 0s 1.2s opacity;
      opacity: 0;
      height: 0px;
      overflow: hidden;

      .sub-heading {
        transition: .6s 2.2s opacity;
        opacity: 0;
      }
    }
  }

  .right {
    opacity: 0;
    top: -100px;
    transition: .6s .6s top, .6s .6s opacity;

    .visual {
      opacity: 0;

      &:nth-child(1) {
        transition: .4s 3s opacity;
      }
      &:nth-child(2) {
        transition: .4s 3.4s opacity;
      }
      &:nth-child(3) {
        transition: .4s 3.8s opacity;
      }
    }

    .videos .box {
      // opacity: 0;
      transition: .6s 1.8s all;
      margin-left: 99px;
      margin-right: 99px;
      width: 0px;
      height: 0px;
    }

    .videos .sub-heading {
      transition: .6s 2.4s opacity;
      opacity: 0;
    }

    .news-list .box {
      // opacity: 0;
      transition: .6s 1.2s all;
      margin-left: 99px;
      margin-right: 99px;
      width: 0px;
    }

    .news-list .news {
      transition: .6s 2.4s opacity;
      opacity: 0;
    }

    .news-list .sub-heading {
      transition: .6s 3s opacity;
      opacity: 0;
    }

    
  }

  .heading {
    margin-top: 60px;
    text-align: center;

    .heading-content {
      position: relative;
      display: inline-block;
      padding: 0 1px;
      .base-border;
      border-width: 0 1px;

      .bg-left {
        position: absolute;
        top: 2px;
        left: -1px;
        width: 1px;
        height: 4px;
        .base-background-color(1);
      }

      .bg-right {
        position: absolute;
        top: 2px;
        right: -1px;
        width: 1px;
        height: 4px;
        .base-background-color(1);
      }
      

      .text {
        padding: 0 20px;
        .base-color(.95);
        font-size: 12px;
        font-family: Arial;
        line-height: 1em;
        .base-border;
        border-width: 0 1px;

        span {
          width: 6px;
          height: 2px;
          display: inline-block;
          .base-background-color(1);
          position: relative;
          top: -3px;
        }
      }
    }
  }


}

.page-home .left {
  position: absolute;
  
  width: 200px;
  height: 100%;
  



  .logo {
    position: relative;
    left: -20px;
    margin-top: 30px;

    img {
      width: 250px;
    }
  }

  .sub-logo {
    position: relative;
    margin-top: 20px;
    text-align: center;

    img {
      
    }
  }

  

  .menu {
    margin-top: 5px;
    .base-border;
    border-top: none;
    border-bottom: none;
    position: relative;


    .sub-heading {
      position: absolute;
      text-align: center;
      top: 256px;
      // right: 100%;
      left: 0px;
      font-size: 8px;
      line-height: 1em;
      .base-color(.8);
      font-family: Serif;
      transform: rotate(270deg);
      transform-origin: 0px 14px;
    }

    .menu-item {
      border-width: 1px 3px;        
      .base-border;
      border-width: 1px 3px;

      

      .menu-item-content {
        overflow: hidden;
        margin: 2px 0;
        position: relative;
        width: 194px;
        left: -1px;
      }

      a {
        display: block;
        font-size: 14px;
        font-family: Arial;
        font-weight: normal;
        line-height: 30px;
        padding-left: 25px;
        padding-right: 15px;
        .base-background-color(0.075);
        .base-border;
        .border-color(1);
        // .base-color;
        border-left-color: transparent;
        border-right-color: transparent;
        z-index: 1;

        &.router-link-active, &:hover {
          color: rgba(27,255,104,1);

          .status {
            .on {
              display: block;
            }
            .off {
              display: none;
            }
          }
        }

        &:hover {
          .base-background-color(0.025);
          // background-color: rgba(0,0,0,.075);
        }

        .status {
          float: right;
          opacity: 0.8;
          /* font-family: '宋体'; */

          .on {
            display: none;
          }
        }

        .top-left {
          top: -5px;
          left: -4px;
        }
        .top-right {
          top: -5px;
          right: -4px;
        }
        .bottom-left {
          bottom: -5px;
          left: -4px;
        }
        .bottom-right {
          bottom: -5px;
          right: -4px;
        }

        .box-inner {
          .base-border;
          margin: 2px;
        }

      }

      .diagonal-1 {
        position: absolute;
        top: 2px;
        left: 0;
        width: 200px;
        height: 1px;
        z-index: 0;
        .base-background-color(0.2);
        transform: rotate(8deg);
        transform-origin: top left;
      }

      .diagonal-2 {
        position: absolute;
        top: 1px;
        left: 0;
        width: 200px;
        height: 1px;
        z-index: 0;
        .base-background-color(0.2);
        transform: rotate(-8deg);
        transform-origin: top right;
      }
    }
    .divider {
      .base-background-color(0.4);
      margin: 2px 0;
      position: relative;

      &:first-child {

        .bg-top {
          display: none;
        }

        .bg-bottom {
          display: none;
        }
      }

      &:last-child {

        .bg-top {
          display: none;
        }

        .bg-bottom {
          display: none;
        }
      }

      .bg-top {
        position: absolute;
        top: -2px;
        left: 50%;
        margin-left: -1px;
        width: 2px;
        height: 1px;
        .base-background-color(0.4);
      }

      .bg-bottom {
        position: absolute;
        bottom: -2px;
        left: 50%;
        margin-left: -1px;
        width: 2px;
        height: 1px;
        .base-background-color(0.4);
      }

      .bg-center {
        width: 4px;
        height: 2px;
        position: relative;
        left: 50%;
        margin-left: -2px;
        .base-background-color(1);
        border-style: solid;
        border-width: 0 1px;
        border-color: #000;
      }
    }
  }

  .left-footer {
    position: absolute;
    bottom: 10px;
    left: 6px;
    .copyright-1, .copyright-2 {
      display: block;
      font-family: 'Microsoft YaHei';
      font-size: 12px;
      // .base-color;
      // opacity: 0.9;
      
    }
    .copyright-1 {
      margin-top: 10px;
      width: 200px;
      position: relative;
      left: 0px;
    }
    .copyright-2 {
      position: absolute;
      left: 196px;
      bottom: 0;
      width: 300px;
    }
    .btn-3 {
      font-family: 'SimSun';
      width: 22px;
      height: 22px;
      color: #59e0fd;
      font-size: 20px;
      line-height: 22px;
      font-weight: normal;
      line-height: 1em;
      vertical-align: bottom;
      text-shadow: 0 0 6px #59e0fd;
      opacity: 1;
      position: relative;
      left: -2px;
    }
  }
}

.page-home .right {
  position: absolute;
  right: 41px;
  width: 200px;
  height: 100%;


  .visuals {
    margin-top: 10px;
    text-align: center;
    overflow: hidden;
    .visual {
      .visual-btn;
      float: left;
      margin-left: 10px;

      &:first-child {
        margin-left: 0;
      }
    }
  }

  .visual-btn {
    display: block;
    overflow: hidden;
    text-align: center;
    cursor: pointer;

    &.active, &:hover {
      .point {
        border-color: rgba(27,255,104,1);

        .point-content {
          background-color: rgba(27,255,104,1);
        }

      }
      .box {
        color: rgba(27,255,104,1);

        .top-left, .top-right, .bottom-left, .bottom-right {
          border-color: rgba(27,255,104,1);
        }
      }
    }

    .point {
      margin-top: 5px;
      display: inline-block;
      width: 14px;
      height: 14px;
      .base-border;
      .border-color(0.8);
      border-radius: 50%;

      .point-content {
        width: 8px;
        height: 8px;
        .base-background-color(0.8);
        margin: 2px;
        border-radius: 50%;
      }

    }
    
    .box {
      margin-top: 5px;
      width: 60px;
      text-align: center;
      border-color: transparent;
      font-family: serif;
      line-height: 18px;
      font-size: 12px;
      .base-color;
      background-color: rgba(0,0,0,.4);

      .top-left {
        background-image: none;
        width: 6px;
        height: 3px;
        top: 0;
        left: 0;
        border-color: rgba( 43, 229, 245, 1);
        border-style: solid;
        border-width: 1px 0 0 1px;
      }

      .top-right {
        background-image: none;
        width: 6px;
        height: 3px;
        top: 0;
        right: 0;
        border-color: rgba( 43, 229, 245, 1);
        border-style: solid;
        border-width: 1px 1px 0 0;
      }

      .bottom-left {
        background-image: none;
        width: 6px;
        height: 3px;
        bottom: 0;
        left: 0;
        border-color: rgba( 43, 229, 245, 1);
        border-style: solid;
        border-width: 0 0 1px 1px;
      }

      .bottom-right {
        background-image: none;
        width: 6px;
        height: 3px;
        bottom: 0;
        right: 0;
        border-color: rgba( 43, 229, 245, 1);
        border-style: solid;
        border-width: 0 1px 1px 0;
      }
    }

  }

  .videos {
    height: auto;
    margin: 0;
    position: absolute;
    width: 100%;
    top: 10%;
    left: 0;
    

    .box {
      position: relative;
      margin-top: 5px;
    }

    .video {
      height: 100%;

      .preview {
        height: 100%;
        
        position: relative;

        .movie-btn {
          position: absolute;
          width: 100%;
          height: 100%;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }
      .title {
        display: none;
      }
    }

    .sub-heading {
      width: 113px;
      position: absolute;
      text-align: center;
      top: -12px;
      left: 100%;
      font-size: 8px;
      line-height: 1em;
      .base-color(.8);
      font-family: Serif;
      transform: rotate(90deg);
      transform-origin: 0px 14px;
    }
  }

  .news-list {
    position: absolute;
    width: 100%;
    top: 35%;
    left: 0;
    
    
    .box {
      margin-top: 5px;
      height: 0px;
      background: rgba(0,0,0,0.6);
    }

    .news-list-box-content {
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      overflow: auto;
    }


    .news {
      padding: 0;
      margin-top: 20px;
      cursor: pointer;

      &:last-child {
        margin-bottom: 20px;
      }

      .time {
        .base-color;
        font-size: 12px;
        opacity: 0.9;
      }
      .title {
        margin: 5px 10px 0px 18px;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        opacity: 0.8;
        // white-space: nowrap;
      }
    }

    .sub-heading {
      width: 260px;
      position: absolute;
      text-align: center;
      top: -12px;
      left: 100%;
      font-size: 8px;
      line-height: 1em;
      .base-color(.8);
      font-family: Serif;
      transform: rotate(90deg);
      transform-origin: 0px 14px;
    }

    .more {
      margin-top: 20px;

      a {
        display: block;
        margin: 0 auto;
        width: 120px;
        height: 24px;
        line-height: 24px;
        .base-border;
        background-color: rgba(0,0,0,.4);
        text-align: center;
        line-height: 22px;
        .base-color;
        font-family: Arial;

        &:hover {
          .green-color;
          background-color: rgba(0,0,0,.8);
          .border-color(.45);
        }
      }
    }
  }

  .right-footer {
    position: absolute;
    bottom: 20px;
    left: 0;
    overflow: hidden;

    .btn-share {
      .visual-btn;
      display: block;
      float: left;
      margin-left: 20px;
      margin-top: 5px;
      // cursor: default;

    }

    .btn-circle {
      float: left;
      display: block;
      margin-left: 10px;
      cursor: pointer;

      &:hover {
        .point {
          .point-content {
            background-color: rgba(0, 0, 0, .6);
            // .base-background-color(.025);

            .fa {
              .green-color;
            }
          }
        }
      }

      .point {
        margin-top: 0px;
        
        width: 40px;
        height: 40px;
        .base-border;
        .border-color(0.5);
        border-radius: 50%;

        .point-content {
          width: 34px;
          height: 34px;
          .base-border;
          .border-color(1);
          border-width: 1px;
          margin: 2px;
          background-color: rgba(0, 0, 0, .4);
          // .base-background-color(.05);
          background-image: -webkit-linear-gradient(top, transparent 2px, rgba(43,229,245,.6) 3px);
          background-size: 100% 3px;
          background-repeat: repeat-y;
          border-radius: 50%;

          .fa {
            display: block;
            padding: 8px 8px;
            font-size: 16px;
            line-height: 1em;
            .base-color;
            text-shadow: 1px 1px 10px rgba(43,229,245,.6);
          }

        }

      }
    }
  }
}

.page-home .beian-info {
    position: absolute;
    bottom: 10px;
    right: 250px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    color: rgba(255,255,255,.75);
    a {
      color: inherit;
      &:hover {
        color: #fff;
      }
    }
}

.page-news {


  .news-list {
    margin-left: 40px;

    .news {
      margin-bottom: 60px;
      cursor: pointer;

      

      .time {
        .base-color;
        // .base-border;
        // border-width: 0 0 1px 0;
        padding-bottom: 10px;
        line-height: 1em;
        font-weight: 900;
      }

      .title {
        margin-top: 10px;
        font-size: 18px;
        font-weight: 900;
      }

      .desc {
        margin-top: 60px;
        line-height: 1.5em;
      }
    }
  }


}

.page-popup {
  // display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  // background-color: rgba(0, 0, 0, 0.85);
  background-image: url(/web-static/img/popup-bg.png);
  overflow: auto;
  cursor: pointer;
  z-index: 11;

  .btn-close {
    position: absolute;
    top: 0;
    left: 100%;
    margin-left: 20px;
    width: 40px;
    height: 40px;
    background-image: url(/web-static/img/close.png);
    cursor: pointer;
  }

  .page-popup-content {
    // display: none;
    position: absolute;
    top: 50%;
    
    left: 50%;
    width: 1000px;
    margin-left: -500px;
    height: 626px;
    margin-top: -313px;
    // .base-border;
    cursor: auto;
    // transition: all 10s;
    // opacity: 0;



    .box-inner {
      background: rgba(0, 0, 0, 1);
      height: 620px;
      overflow: auto;
    }
  }

  .popup-article {
    position: relative;
    padding: 20px;
    line-height: 1.5em;
    
    .article-title {
      margin-top: 10px;
      font-size: 26px;
      .base-color(1);
    }
    .article-time {
      font-size: 12px;
      .base-color(1);
      float: right;
    }
    .article-content {
      margin-top: 30px;
      line-height: 1.5em;
      color: rgba(255,255,255,.9);
      p {
        margin-top: 20px;
        img {
          margin-top: 10px;
        }
      }
      b {
        color: #fff;
      }
      img {
        max-width: 100%;
      }
    }
    
  }

  .popup-video {
    width: 100%;
    height: 612px;
    padding: 0;
    margin: 0;
    background-color: #000;
  }

  .popup-share {
    height: 100%;
    overflow: hidden;
    text-align: center;
    background: 
      -webkit-linear-gradient(top, transparent 14px, rgba(28,238,255,0.2) 15px),
          -webkit-linear-gradient(left, transparent 14px, rgba(28,238,255,0.2) 15px);
      background-size: 15px 15px;
      background-repeat: repeat;
    .weibo, .weixin {
      // float: left;
      display: inline-block;
      .base-color;
      font-size: 18px;
      line-height: 1.5em;
      margin: 120px 0px;
      padding: 0 60px;

      img {
        margin-top: 10px;
        display: block;
      }
    }

    .weibo {
      .base-border;
      border-width: 0 1px 0 0;
    }
  }
}



.page-keyword, .page-goods {

  .right {
    padding-left: 20px;
    margin-top: 72px;
  }


  .keywords, .goods {
    

    .keyword, .good {
      margin-bottom: 60px;
      // .base-border;
      // border-width: 1px 0 0 0;
      overflow: hidden;

      .title {
        .base-color;
        margin-top: 10px;
        font-size: 18px;
        font-weight: 900;
      }

      .content, .content-full {
        margin-top: 60px;
        line-height: 1.5em;
        p {
          img {
            max-width: 100%;
          }
        }
      }

      .content {
        float: left;
        width: 660px;
      }

      .picture {
        display: block;
        width: 300px;
        float: right;
        overflow: hidden;
        

        .box {
          .border-color(0.2);
        }

        img {
          width: 100%;
        }
        
      }
    }
  }
}

.page-cast {

  .right {
    padding-left: 20px;
    margin-top: 100px;
  }


  .staff, .cast {
    width: 460px;
    display: inline-block;

    .heading {
      position: relative;
      .base-color;
      font-size: 16px;
      line-height: 1em;
      font-family: Arial;

      .heading-bg {
        width: 395px;
        height: 2px;
        .base-background-color(1);
        position: absolute;
        top: 7px;
        left: 65px;
      }
    }

    .box {
      margin-top: 20px;
    }
    
    .box-content {
      height: 300px;
      overflow: auto;
      padding: 10px 0 30px 0;
      .base-border;
      margin: 2px;
      background-color: rgba(0,0,0,.6);
    }
    .item {
      display: block;
      text-align: center;
      margin-top: 20px;

      .position, .name {
        width: 200px;
        vertical-align: middle;
        display: inline-block;
        .base-color;
        font-size: 14px;
        font-family: Arial;
        line-height: 1em;
        padding: 3px 0;
      }

      .position {
        // font-style: italic;
        font-size: 12px;
        text-align: right;
        // .base-border;
        // border-width: 0 0 0 1px;
      }

      .name {
        text-align: left;
        // .base-border;
        // border-width: 0 1px 0 0px;
      }

      .divider {
        vertical-align: middle;
        display: inline-block;
        margin: 0 15px;
        width: 2px;
        height: 20px;
        font-size: 20px;
        line-height: 1em;
        .base-background-color(.4);
        transform: rotate(30deg);
        overflow: hidden;
        .base-color;
      }

      .name {
        color: #fff;
      }
    }
  }

  .staff {
    margin-right: 52px;
  }

  .horizontal-line {
    margin-top: 60px;
    margin: 60px 120px;
    height: 1px;
    .base-background-color(.2);
    position: relative;

    .bg-left, .bg-right {
      position: absolute;
      top: 0;
      width: 6px;
      height: 1px;
      .base-background-color(.6);
    }

    .bg-left {
      left: 0;
    }

    .bg-right {
      right: 0;
    }

    .bg-center {
      position: absolute;
      top: -1px;
      left: 50%;
      width: 6px;
      margin-left: -3px;
      height: 2px;
      .base-background-color(1);
    }
  }
}

.page-character, .page-mechanic {

  .page-content {
    .left {
      width: 250px;

      .nav {
        .nav-item {
          overflow: hidden;
          position: relative;
          
          &.active {
            .nav-item-bg {
              width: 100%;
            }
          }

          .nav-item-bg {
            position: absolute;
            top: 0;
            left: 0;
            transition: .4s width;
            width: 0px;
            height: 100%;
            .base-background-color(.15);
            z-index: -1;
          }

          &:hover {
            .box {
              background-size: 100% 100%;
              
            }
            .nav-item-bg {
              width: 100%;
            }
          }

          .box {
            width: 250px;
            height: 40px;
            .base-background-color(.025);
            position: relative;
            .border-color(.2);

            img.bg {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1;
            }

            .placeholder {
              width: 250px;
              height: 40px;
              text-align: center;
              line-height: 40px;
              font-size: 14px;
              .base-color(.8);
            }
          }

          
        }
      }
    }

    .right {
      width: 950px;
      padding-left: 40px;
      margin-top: 70px;
    }

    .intro {
      overflow: hidden;
      // background: url(/web-static/img/bg-pattern.png) repeat;
      // background-color: #000;

      .box {
        .border-color(.2);
      }

      img {
        width: 100%;
      }

      .placeholder {
        height: 700px;
      }
    }
  }
}

.page-story {

  .page-content .left {
    width: 320px;

    .nav {
      overflow: hidden;
      .nav-item {
        float: left;
        margin-right: 20px;
        width: 86px;

        &:hover {
          .picture {
            .box {
              .border-color(0.25);
              .base-background-color(0.075);
            }
          }
        }

        .picture {
          overflow: hidden;
          display: inline-block;
        }

        .box {
          .base-background-color(0.05);
          .border-color(0.1);
          position: relative;
          padding: 2px;

        }

        .bg {
          
          width: 80px;
          height: 45px;
        }

        .placeholder {
          width: 80px;
          height: 45px;
          text-align: center;
          line-height: 1em;
          font-size: 12px;
          line-height: 14px;
          padding-top: 8px;
          .base-color(.8);
        }

        .title {
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .page-content .right {
    position: relative;
    width: 880px;
    padding-left: 40px;
    margin-top: 70px;
    // transition: all 1s;
    // top: -100px;
    

    &.init {
      top: 0px;
      // opacity: 1;
    }
  }

  .intro {
    overflow: hidden;
    background-color: rgba(0,0,0,0.5);
    position: relative;
    top: 0px;
    left: 0px;
    
    &.transition {
      // transition: opacity .6s, left .6s;
    }

    > .box {
      border-color: transparent;
    }

    .title {
      text-align: center;
      font-size: 30px;
      // font-style: italic;
      // .base-color;
      // .base-background-color(0.05);
      background-color: rgba(0,0,0,0.5);
      overflow: hidden;
      

      .box {
        padding: 20px;
        .border-color(.3);
        border-style: dashed;
        border-left-color: transparent;
        border-right-color: transparent;

        .top-left, .top-right, .bottom-left, .bottom-right {
          
        }

      }
      
    }

    .preview {

      padding: 0px;
      // width: 840px;
      margin-top: 60px;
      // border-width: 1px 0;
      position: relative;
      left: 0px;
      overflow: hidden;
      img {
        width: 100%;
      }
      .placeholder {
        width: auto;
        height: 470px;
        .base-background-color(.05);
        .border-color(.2);
      }
    }

    .imgs {
      margin-top: 10px;
      text-align: center;
      img {
        display: inline-block;
        width: 60px;
        margin: 2px;
        cursor: pointer;
      }
    }

    .content {
      margin-top: 40px;
      
      line-height: 1.5em;
      overflow: hidden;

      .box {
        // border-color: transparent;
        padding: 20px;
        border-style: dashed;
        .border-color(0.2);
        border-left-color: transparent;
        border-right-color: transparent;
        background-color: rgba(0,0,0,0.5);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue